export default "<div [id]=\"ids\"></div>\r\n";